const LEGACY_KEY = "skipEmailVerificationUntil";

export const clearEmailVerificationSkip = (email: string) => {
  localStorage.removeItem(`skipEmailVerificationUntil_${email}`);
  localStorage.removeItem(LEGACY_KEY);
};

export const saveEmailVerificationSkip = (email: string, expiresAt: Date, userId?: string) => {
  const payload = {
    expiresAt: expiresAt.toISOString(),
    ...(userId ? { userId } : {}),
  };
  localStorage.setItem(`skipEmailVerificationUntil_${email}`, JSON.stringify(payload));
  localStorage.removeItem(LEGACY_KEY);
};
